<form [formGroup]="formGroup" class="dynamic-input-array">
  <ng-container [formArrayName]="name">
    <div *ngFor="let control of controls; index as i" class="dynamic-input-array_control">
      <ng-container [ngSwitch]="inputType">
        <!--  Numeric -->
        <nx-formfield *ngSwitchCase="'number'" [label]="label | translate : translateArgs(i)"
                      [ngClass]="{ 'has-error': hasError }">
          <input [formControlName]="i" nxInput type="number" inputmode="decimal" />
        </nx-formfield>

        <!--  Checkbox -->
        <nx-checkbox *ngSwitchCase="'checkbox'" class="nx-margin-bottom-s" [formControlName]="i">
          {{ label | translate : translateArgs(i) }}
        </nx-checkbox>

        <!--  Number stepper -->
        <div *ngSwitchCase="'numberStepper'" class="number-stepper-margin-reset" nxRow rowJustify="end">
          <nx-number-stepper
            [min]="1"
            [max]="500"
            [formControlName]="i"
            [leadingZero]="false"
            [ngClass]="{ 'has-error': hasError }"
            size="normal"
          ></nx-number-stepper>
        </div>

        <!--  Yes no -->
        <qbe-radio-button-group *ngSwitchCase="'yesNo'">
          <qbe-radio-button
            *ngFor="let button of yesNoValues; index as buttonIndex"
            (click)="handleRadioButtonsChange(buttonIndex, i)"
            [ngClass]="{ 'has-error': hasError }"
            [selected]="getSelectedRadioButton(i) === buttonIndex"
          >{{ 'common.' + button.label | translate }}</qbe-radio-button
          >
        </qbe-radio-button-group>

        <!--  Phone number -->
        <nx-formfield *ngSwitchCase="'phoneNumber'" [label]="label | translate : translateArgs(i)"
                      [ngClass]="{ 'has-error': hasError }">
          <input nxInput [formControlName]="i" nxMask="000-000-000" />
          <span nxFormfieldPrefix>+48</span>
        </nx-formfield>

        <!--  Select -->
        <nx-formfield *ngSwitchCase="'select'" [label]="label | translate : translateArgs(i)"
                      [ngClass]="{ 'has-error': hasError }">
          TODO
        </nx-formfield>

        <!--  Date -->
        <nx-formfield *ngSwitchCase="'date'" [label]="label | translate : translateArgs(i)"
                      [ngClass]="{ 'has-error': hasError }">
          <input
            nxDatefield
            nxInput
            [parseFormat]="['YYYY/MM/DD', 'DD/MM/YYYY']"
            displayFormat="DD/MM/YYYY"
            [datepicker]="startDatepicker"
            [formControlName]="i"
          />
          <span nxFormfieldHint>{{'common.date_input.hint' | translate}}</span>
          <nx-datepicker-toggle [for]="startDatepicker" nxFormfieldSuffix></nx-datepicker-toggle>
          <nx-datepicker #startDatepicker></nx-datepicker>
        </nx-formfield>

        <!--   Year -->
        <ng-container *ngSwitchCase="'year'">
          <nx-formfield [label]="label | translate : translateArgs(i)" class="year-picker"
                        [ngClass]="{ 'has-error': hasError }">
            <input [formControlName]="i" nxInput />
            <button nxPlainButton type="button" (click)="showYearPicker = i">
              <nx-icon name="calendar" class="picker-icon"></nx-icon>
            </button>
            <span nxFormfieldHint>{{'common.year_input.hint' | translate}}</span>
            <qbe-year-picker
              *ngIf="showYearPicker === i"
              style="z-index: 1"
              [startingYear]="startingYear"
              (yearChange)="handleYearChange($event, i)"
              [min]="minDateYearPicker"
              [max]="maxDateYearPicker"
              (closeModal)="showYearPicker = null"
            ></qbe-year-picker>
          </nx-formfield>
        </ng-container>

        <!--  Text -->
        <nx-formfield *ngSwitchDefault [label]="label | translate : translateArgs(i)"
                      [ngClass]="{ 'has-error': hasError }">
          <input *ngIf="!mask" [formControlName]="i" nxInput />
          <input *ngIf="mask" [formControlName]="i" nxInput [nxMask]="mask" />
        </nx-formfield>
      </ng-container>
    </div>
  </ng-container>
</form>
